import { FlowCardLoading } from '@components/FlowCard'
import { VerifyCardDetails } from '@components/RouteComponents'
import { createFileRoute } from '@tanstack/react-router'

import { ensureUserTermsQueryData } from '../-utils/ensureUserTermsQueryData'

export const Route = createFileRoute('/_initialized/verifyCardDetails')({
  loader: ({ context }) => ensureUserTermsQueryData(context),
  component: VerifyCardDetails,
  pendingComponent: FlowCardLoading,
})
